import { api } from "@/lib/api";

let cachedCatalog = null;
let pendingCatalog = null;

/** Share one in-flight request and cache successful catalog data for this page session. */
export function getReferenceCatalog() {
  if (cachedCatalog) return Promise.resolve(cachedCatalog);
  if (!pendingCatalog) {
    pendingCatalog = api.get("/references/catalog")
      .then(response => {
        cachedCatalog = response.data;
        return cachedCatalog;
      })
      .finally(() => { pendingCatalog = null; });
  }
  return pendingCatalog;
}

export function clearReferenceCatalogCache() {
  cachedCatalog = null;
  pendingCatalog = null;
}
